import { createFeatureActionNamer } from '../../../../../../../redux/action-name';

const getActionName = createFeatureActionNamer('underwriting-policy-details');

export const UPDATE_UNDERWRITING_POLICY_DETAILS = getActionName(
    'UPDATE_UNDERWRITING_POLICY_DETAILS'
);
